import React, {useState, useEffect} from "react";
import apiRequests from "../../Component/axios/config/config";
import Loading from "../../Component/Loading/Loading";


export default function MyProfile() {


    const [profile, setProfile] = useState({
        userName: "",
        lastName: "",
        firstName: "",
        password: ""
    });

    const [loading, setLoading] = useState(true);
    const [loadingBtn, setLoadingBtn] = useState(false);



    useEffect(() => {
        getProfile()
    }, [])



    function getProfile() {

        apiRequests.get("/api/admin/v1/get-my-profile")
            .then((response) => {
                setProfile({
                    userName: response.data.data.userName || "-",
                    lastName: response.data.data.lastName || "-",
                    firstName: response.data.data.firstName || "-",
                })
            })
            .catch(() => {
            })
            .finally(() => setLoading(false));
    }

    function updateProfile() {

        setLoadingBtn(true)
        apiRequests.patch("/api/admin/v1/edit-my-profile", profile)
            .then((response) => {
                window.location.reload()
            })
            .catch(() => {
            })
            .finally(() => setLoadingBtn(false));

    }

    return (


        <div className="p-6">

            <div className="text-3xl font-bold text-gray-800 mb-6">
                My Profile
            </div>


            <div className="grid grid-cols-2 auto-cols-auto md:flex md:flex-col gap-3 mt-3">

                {loading ?

                    <Loading/>
                    :
                    <>

                        <div className="flex flex-col gap-2 text-xl">
                            user name
                            <input className="min-h-10 border-2 border-marginColor-shade4 w-2/3 p-2 rounded-md"
                                   value={profile.userName}
                                   onChange={(e) => setProfile({...profile, userName: e.target.value})}
                            />
                        </div>

                        <div className="flex flex-col gap-2 text-xl">
                            Last Name
                            <input value={profile.lastName}
                                   onChange={(e) => setProfile({...profile, lastName: e.target.value})}
                                   className="min-h-10 border-2 border-marginColor-shade4 w-2/3 p-2 rounded-md"/>
                        </div>

                        <div className="flex flex-col gap-2 text-xl">
                            First Name
                            <input value={profile.firstName}
                                   onChange={(e) => setProfile({...profile, firstName: e.target.value})}
                                   className="min-h-10 border-2 border-marginColor-shade4 w-2/3 p-2 rounded-md"/>
                        </div>

                        {/*<div className="flex flex-col gap-2 text-xl">*/}
                        {/*    Email*/}
                        {/*    <input value={profile.email}*/}
                        {/*           readOnly*/}
                        {/*        // onChange={(e) => setProfile({...profile, Email: e.target.value})}*/}
                        {/*           className="min-h-10 border-2 border-marginColor-shade4 w-2/3 p-2 rounded-md"/>*/}
                        {/*</div>*/}
                        <div className="flex flex-col gap-2 text-xl">
                            New PassWord
                            <input onChange={(e) => setProfile({...profile, password: e.target.value})}
                                   className="min-h-10 border-2 border-marginColor-shade4 w-2/3 p-2 rounded-md"/>
                        </div>

                        {/*<div className="flex flex-col gap-2 text-xl">*/}
                        {/*    Update At*/}
                        {/*    <input value={new Date(profile.updatedAt).toLocaleDateString("en")} readOnly className="min-h-10 border-2 border-marginColor-shade4 w-2/3 p-2 rounded-md"/>*/}
                        {/*</div>*/}

                        {/*<div className="flex flex-col gap-2 text-xl">*/}
                        {/*    Create At*/}
                        {/*    <input value={new Date(profile.createdAt).toLocaleDateString("en")} readOnly className="min-h-10 border-2 border-marginColor-shade4 w-2/3 p-2 rounded-md"/>*/}
                        {/*</div>*/}
                    </>
                }


            </div>


            {!loading &&
                <button
                    onClick={updateProfile}
                    className="mt-6 text-lg text-white hover:bg-white hover:text-baseColor-first py-2 px-4 rounded-md border-2 border-buttonColor-shade5 bg-buttonColor-shade5">

                    {loadingBtn ?

                        "loading ..."
                        :
                        "Update My Profile"
                    }

                </button>

            }

        </div>
    )
}